<template>
    <div class="detail-brief" v-if="status === 1">
        <div :class="{'brief-info-title': true, 'has-next': baseInfo.cutPriceActivity && baseInfo.cutPriceActivity.activityId}" v-if="!supportGroupBuying && !(prdTmpId === 8 && baseData.saleRemainingTime)">
            <div class="title" v-if="baseData.title">
                <span>{{baseData.title.productName}}</span>
                <span class="no-refund" v-if="baseData.canRefund === 0">【不可退】</span>
            </div>
            <div class="price-info" v-if="baseData.price">
                <span class="base-price"><i class="symbol">￥</i><span class="price">{{startPrice}}</span>起</span>
                <span class="instruction" v-if="baseData.price.priceDescription && baseData.price.priceDescription.length" @click="changeShowPriceTip">价格说明</span>
                <div class="sale" v-if="prdTmpId === 5">
                    <span v-if="baseData.count.travelCount">{{baseData.count.travelCount}}人出游</span>
                    <span v-if="baseData.count.travelMonthlyCount">近30天{{baseData.count.travelMonthlyCount}}人出游</span>
                </div>
                <div class="sale" v-else>
                    <span v-if="baseData.count.travelCount">累计销量 <em>{{baseData.count.travelCount}}</em></span>
                    <span v-if="baseData.count.travelMonthlyCount">月销 <em>{{baseData.count.travelMonthlyCount}}</em></span>
                </div>
            </div>
            <!-- <div class="special-info" @click="expandBtn" v-if="baseInfo.specialTips && baseInfo.specialTips.entryReminder && baseInfo.specialTips.entryReminder.tips && baseInfo.specialTips.entryReminder.tips.length > 0">  
                <div :class="expandBtnStatus ? 'special-content-show' : 'special-content'">
                    <img :src="baseInfo.specialTips.entryReminder.iconUrl"/>
                    <span class="contentArea">
                        <span v-for="(tip, index) in baseInfo.specialTips.entryReminder.tips" :key="index">{{tip.content}}<br/></span>
                    </span>
                </div>
                <span v-if="showBtn">
                    <span v-if="expandBtnStatus" class="expand-btn">收起</span>
                    <span v-else class="expand-btn-show">... 展开</span>
                </span>
            </div> -->
        </div>

        <group-buying-brief :briefTitle="baseData.title.productName" :count="baseData.count" :supportGroupBuying="supportGroupBuying" :groupActivity="groupActivity" :startPrice="startPrice" :saleRemainingTime="baseData.saleRemainingTime" :canRefund="baseData.canRefund" v-else></group-buying-brief>

        <!-- 疫情提醒 -->
        <div
            class="epidemic-top"
            v-if="(baseInfo.classBrandParentId == 1 || baseInfo.classBrandParentId == 2 || baseInfo.classBrandParentId == 8 || baseInfo.classBrandParentId == 22) && (specialTipNew || specialTipOld) && (baseInfo.classBrandId != 115)"
            @click="isShowPopup = true"
        >
            <img class="left" :src="specialTip.icon" alt="" />
            <span>{{ specialTip.title }}</span>
            <img
                class="right"
                src="https://m3.tuniucdn.com/fb2/t1/G7/M00/13/68/CkC9r2HvrfmIGiAQAAADkKvRU-cAAHX3gP__FgAAAOo231.png"
                alt=""
            />
        </div>

        <div class="epidemic-popup" v-if="isShowPopup">
            <div class="content">
                <div class="title">出行提醒</div>
                <div class="info">
                    <div v-if="specialTips1">
                        <div class="item-title">
                            <img
                                class="icon"
                                :src="specialTips1.icon"
                                alt=""
                            />
                            {{ specialTips1.cityName || "出发地" }}出发提醒
                        </div>
                        <div class="item-content">
                            {{ specialTips1.content }}
                        </div>
                    </div>
                    <div v-if="specialTips2" class="line"></div>
                    <div v-if="specialTips2">
                        <div class="item-title">
                            <img
                                class="icon"
                                src="https://m1.tuniucdn.com/fb2/t1/G7/M00/13/63/CkC9Y2Hw19eISAf5AAAGtQX79RkAAHXQQP_-TMAAAbN722.png"
                                alt=""
                            />
                            抵达{{ baseInfo.destinationName || "目的地" }}提醒
                        </div>
                        <div class="item-content">
                            {{ specialTips2 }}
                        </div>
                    </div>
                    <div class="footer-tip">
                        *以上信息供您参考，因疫情传播风险较强，各地疫情防控政策可能随时调整，请您在出行前务必参照当地最新疫情防控规定，合理安排出行。
                    </div>
                </div>
                <div class="footer">
                    <div class="confirm" @click="isShowPopup = false">
                        我知道了
                    </div>
                </div>
            </div>
        </div>

        <!-- 途牛黑卡 -->
        <blackCardDiscout v-if="blackCard && blackCard.blackCardActivity " class="base-additem" :location="blackCard && blackCard.blackCardActivity && blackCard.blackCardActivity.blackCardUrl">
        </blackCardDiscout>
        <bargain
            v-if="baseInfo.cutPriceActivity && baseInfo.cutPriceActivity.activityId"
            :baseData="baseInfo.cutPriceActivity"
            :productId="baseInfo.productId"
            :productName="baseInfo.productName"
            :classBrandParentName="baseInfo.classBrandParentName"
            :image="baseInfo.image"
            :destinationName="baseInfo.destinationName"
            :lowestPrice="baseInfo.head && baseInfo.head.price && baseInfo.head.price.startPrice"
            :remarkSatisfaction="baseInfo.remarkSatisfaction"
            :travelCount="baseInfo.head && baseInfo.head.count && baseInfo.head.count.travelCount"
        ></bargain>
        <touch-strip class="base-additem" v-if="Array.isArray(baseData.brightPointList) && baseData.brightPointList.length" v-on:more="changeShowPointTip">
            <ul class="item-group">
                <li v-for="(item, index) in baseData.brightPointList" v-if="index < 4" :key="index">
                    <i class="icon-features"></i>{{item.brightPointName}}
                </li>
            </ul>
        </touch-strip>
        <!-- <div class="announcement" v-if="announcement">{{announcement}}</div> -->
        <Popup :show="showPrice" title="价格说明" v-if="baseData && baseData.price && baseData.price.priceDescription && baseData.price.priceDescription.length" class="price-tip-popup">
            <div class="price-tip" v-for="item in baseData.price.priceDescription" :key="item" v-if="item && item.length" v-html="item.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
        </Popup>
        <Popup :show="showBrightPoint" title="产品亮点" class="bright-point-popup" v-if="Array.isArray(baseData.brightPointList)">
            <dl class="point-tip" v-for="(item, index) in baseData.brightPointList" :key="index">
                <dt><i class="icon-features"></i>{{item.brightPointName}}</dt>
                <dd>{{item.brightPointDescription}}</dd>
            </dl>
        </Popup>
    </div>
    <div class="detail-brief" v-else>
        <div :class="{'brief-info-title': true, 'has-next': baseInfo.cutPriceActivity && baseInfo.cutPriceActivity.activityId}">
            <div class="title" v-if="baseData.title">
                {{baseData.title.productName}}
            </div>
            <div class="no-price">
                暂无报价
            </div>
        </div>
    </div>
</template>

<script>
import Popup from '@/components/Popup';
import TouchStrip from '@/components/TouchStrip';
import Bargain from '@/components/detail/Bargain';
import blackCardDiscout from '@/components/blackCardDiscout';
import groupBuyingBrief from './groupBuying/groupBuyingBrief';

export default {
    name: 'brief',
    data() {
        return {
            showPrice: {isShow: false},
            showBrightPoint: {isShow: false},
            blackCardUrl: '',
            expandBtnStatus:false,
            showBtn:true,
            isShowPopup: false,
            specialTip:{},
            specialTips1: '',
            specialTips2: '',
            specialTipNew: false,
            specialTipOld: false,
        }
    },
    props: {
        blackCard:{
            type:Object,
            default: function () {
                return {}
            }
        },
        status: {
            type: Number,
            default: 1
        },
        baseData: {
            type: Object,
             default: function () {
                return {}
            }
        },
        baseInfo: {
            type: Object,
             default: function () {
                return {}
            }
        },
        prdTmpId: {
            type: Number,
            default: function () {
                return 3
            }
        },
        startPrice: {
            type: Number,
            default: function () {
                return 0
            }
        },
        //是否为拼团产品
        supportGroupBuying: {
          type: Boolean,
          default: false
        },
        groupActivity: {
          type: Object,
          default: () => ({})
        }
    },
    computed: {
        announcement () {
            return this.baseInfo.otherInfo.shop.agencyType === 0 ? '本产品由零售商直售并提供服务' : '';
        }
    },
    created () {
        var _this = this;
        console.log(_this.baseData, _this.baseInfo);
        this.$store.dispatch('detail/getCoronaviru', {
            productId: _this.baseInfo.productId,
            bookCityCode: _this.baseInfo.bookCityCode || 0
        }).then(res => {
            // console.log("brief res ======> ", res);
            _this.specialTip = res;
            // console.log(_this.specialTip, _this.baseInfo.specialTips);
            let num = 0;
            if (_this.specialTip && _this.specialTip.informations && _this.specialTip.informations.length) {
                // console.log("specialTip1");
                _this.specialTipNew = true;
                _this.specialTips1 = _this.specialTip.informations[0];
                num++;
            }

            if (_this.baseInfo.specialTips && _this.baseInfo.specialTips.entryReminder && _this.baseInfo.specialTips.entryReminder.tips && _this.baseInfo.specialTips.entryReminder.tips.length > 0){
                // console.log("specialTip2");
                _this.specialTipOld = true;
                _this.specialTips2 = _this.baseInfo.specialTips.entryReminder.tips[0].content;
                num++;
            }

            if(!_this.specialTip.icon) {
                // console.log("icon 赋值");
                _this.specialTip.icon = _this.baseInfo.specialTips.entryReminder.iconUrl || "https://s.tuniu.net/qn/images/a1c4c269a75af838404a2d62ab770927.jpg";
            };
            _this.specialTip.title =
                num +
                "条公告，" +
                (_this.specialTipNew ? (_this.specialTips1.cityName || "出发地") + "出发提醒" : "") +
                (_this.specialTipNew & _this.specialTipOld ? "，" : "") +
                (_this.specialTipOld ? "抵达" + (_this.baseInfo.destinationName || "目的地") + "提醒" : "");
        })
    },
    mounted() {
        if(document.querySelector('.contentArea') && document.querySelector('.contentArea').offsetHeight <= 35){
            this.showBtn = false;
        }
    },
    methods: {
        expandBtn() {
            this.expandBtnStatus = !this.expandBtnStatus
        },
        changeShowPriceTip() {
            this.showPrice.isShow = true;
        },
        changeShowPointTip() {
            this.showBrightPoint.isShow = true;
        },
        knowAboutBlackCard() {
            window.location.href = this.blackCardUrl;
        }
    },
    components: {
        Popup,
        TouchStrip,
        Bargain,
        blackCardDiscout,
        groupBuyingBrief
    }
}
</script>

<style lang="scss">
@import '../style/common.scss';
.activity-ctn{
    .content{
        padding-left: 0;
    }
    section:nth-child(2) a{
        border-top: 1px solid rgba(0,0,0,0.05);
    }
    .promotion-strip a{
        margin: 0 18px;
    }
     .touch-strip{
        padding: 0px;
    }
    .more {
        color:#383838;
        padding-right: 12px;
    }
}
.promotion-strip h3 {color:#383838;}
.detail-promotionList li.promo-tag span {
    font-size: 11px;
}
.detail-brief {
    //margin-bottom: 9px;
    border-bottom-left-radius: $borderBigRadius;
    border-bottom-right-radius: $borderBigRadius;
    overflow:hidden;
    .brief-info-title {
        overflow: hidden;
        &.has-next {
            border-radius: 0;
        }
    }
    .title {
        background: #fff;
        padding: 10px 18px 0;
        font-size: 20px;
        line-height: 26px;
        font-weight: 600;
        color: $fontStrongColor;
        .no-refund {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #FF6436;
        }
    }
    .price-info {
        background: #fff;
        padding: 0 18px;
        height: 47px;
        font-size: 13px;
        .base-price {
            position: relative;
            padding-left: 16px; 
            color: $fontOrangeColor;
            line-height: 47px;
            font-weight: 600;
            .symbol {
                position: absolute;
                top: -19px;
                left: -5px; 
                font-style: normal;
                font-size: 24px;
                transform: scaleX(0.7);
            }
            .price {
                font-family: "DINCondensed-Bold";
                font-size: 26px;
                margin-right: 3px;
                letter-spacing: 1px;
            }
        }
        .instruction {
            margin-left: 5px;
            line-height: 47px;
            color: $fontWeakColor;
            font-weight: 300;
            touch-action: manipulation;
        }
    }
    .special-info {
        background: #FFFBE8;
        padding: 10px 18px 10px 18px;
        font-size: 13px;
        position: relative;
        text-align: justify;
        .special-content {
            color:#C1874D;
            word-break: break-all;
            text-align: justify;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            display: -webkit-box;
        }
        .special-content-show {
            color: #C1874D;
            word-break: break-all;
            text-align: justify;
            display: inline;
        }
        .special-content img {
            width: 12px;
            margin-right: 5px;
            line-height: 12px;
            vertical-align:middle;
            margin-top: -4px;
        }
        .special-content-show img {
            width: 12px;
            margin-right: 5px;
            line-height: 12px;
            vertical-align:middle;
            margin-top: -4px;
        }
        .expand-btn {
            bottom: 10px;
            position: absolute;
            right: 18px;
            color: #f87d36;
            font-size: 13px;
            background: #fffbe8;
        }
        .expand-btn-show {
            top: 28px;
            position: absolute;
            right: 18px;
            color: #F87D36;
            font-size: 13px;
            background: #FFFBE8;
        }
    }
    .no-price {
        background: #fff;
        padding: 5px 18px 18px;
        font-size: 16px;
        color:rgba(32,48,64,0.75);
        line-height: 24px;
        font-weight: 700;
        border-bottom-left-radius: $borderBigRadius;
        border-bottom-right-radius: $borderBigRadius;
    }
    .sale {
        float: right;
        background: #fff;
        color: $fontColor;
        font-size: 13px;
        line-height: 47px;
        & > span:not(:first-child) {
            margin-left: 5px;
        }
        em {
            font-weight: 700;
            color: #4d505a;
        }
    }
}
div.base-additem {
    padding-top: 6px;
    padding-bottom: 6px;
    background: #fcfcfc;
    .content {
        padding-left: 18px;
        height: 24px;
    }
    ul {
        position: relative;
        height: 24px;
        line-height: 24px;
        overflow: hidden;
        font-size: 12px;
        overflow: hidden;
        li {
            color: $fontColor;
            float: left;
            line-height: 24px;
            margin-right: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:last-child {
                margin-right: 0;
            }
            i {
                display: inline-block;
                height: 24px;
                width: 24px;
                margin-right: 5px;
                color: $greenColor;
                font-size: 26px;
                float: left;
                margin-right: 0;
                margin-left: -6px;
            }
        }
    }
}

// 产品协议
.announcement{
    position: relative;
    line-height: 24px;
    padding: 8px 12px;
    border-top: 1px solid rgba(0,0,0,.08);
    background: #fcfcfc;
    font-size: 12px;
    color: #999;
}


//价格说明
.price-tip-popup {
    .pop-body {
        height: 400px;
        overflow: auto;
        -webkit-overflow-scrolling : touch;
        @supports (height: 50vh) {
            height: 50vh;
        }
    }
    .price-tip {
        position: relative;
        padding: 5px 18px;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
    }
}

.bright-point-popup {
    .pop-body {
        height: 400px;
        @supports (height: 50vh) {
            height: 50vh;
        }
        overflow: auto;
        -webkit-overflow-scrolling : touch;
    }
    .point-tip {
        padding: 0 18px;
        margin-bottom: 20px;
        dt {
            font-size: 16px;
            line-height: 36px;
            color: $fontStrongColor;
            i {
                color: $greenColor;
                margin-right: 8px;
                transform: scale(1.6);
                display: inline-block;
            }
        }
        dd {
            padding-left: 25px;
            font-size: 13px;
            line-break: 19px;
            color: $fontColor;
        }
        
    }
}

.epidemic-top {
    width: 100%;
    height: 35px;
    background: #FEF8E4 100%;
    font-size: 13px;
    display: flex;
    margin:10px 0;
}
.epidemic-top span {
    color: #C1874D ;
    line-height: 35px;
    display: inline-block;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow:ellipsis;
    flex: 1;
    padding-left: 3px;
}
.epidemic-top img {
    display: inline-block;
    height: 18px;
    width: 18px;
    padding-top: 8px;
}
.epidemic-top .left {
    float: left;
    padding-left: 8px;
}
.epidemic-top .right {
    float: right;
    padding-right: 6px;
}
.epidemic-popup {
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index:999;
}
.epidemic-popup .content{
    position: absolute;
    bottom: 0;
    width:100%;
    background:rgba(255,255,255,1);
    border-radius:20px 20px 0 0;
    height: 50%;
    overflow: auto;
}
.epidemic-popup .title{
    font-size: 24px;
    text-align: center;
    font-weight: 700;
    padding:21px 0 4px 0 ;
    position: fixed;
    top: 50%;
    left: 0;
    width: 100%;
    background: #fff;
    border-radius:20px 20px 0 0;
}
.epidemic-popup .info{
    padding: 0 18px;
    margin: 60px 0 70px;
}
.epidemic-popup .footer {
    height: 70px;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
}
.epidemic-popup .confirm{
    height: 42px;
    margin: 6px 18px 20px;
    background: #32C45E;
    font-size: 18px;
    color: #fff;
    text-align: center;
    line-height: 42px;
    border-radius: 21px;
}
.epidemic-popup .item-title{
    font-size: 17px;
    padding-bottom: 12px;
    color:#FF6436;
}
.epidemic-popup .icon{
    width: 17px;
    height: 17px;
    vertical-align: middle;
    padding-bottom: 3px;
}
.epidemic-popup .item-content{
    font-size: 12px;
    line-height: 20px;
    color: #A5A5A5;
}
.epidemic-popup .line{
    height: 1px;
    background-color: #A5A5A5;
    width: 100%;
    margin: 12px 0;
}
.epidemic-popup .footer-tip{
    margin-top: 10px;
    font-size: 12px;
    color: #A5A5A5;
}
</style>



// WEBPACK FOOTER //
// Brief.vue